import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import css from "./ClientsComponent.module.css";
import { TitleMenuClientsComponent } from "../TitleMenuClientsComponent/TitleMenuClientsComponent";
import ClientsListComponent from "../ClientsListComponent/ClientsListComponent";
import { ModalForImportXLS } from "../../../ui";
import { ClientsCreatePhoneClientModal } from "../clientsSectionModal";
import { clientsActions } from "../../../store/slices/clients-slices";
import ClientsCreateInfoModal from "../clientsSectionModal/ClientsCreateInfoModal/ClientsCreateInfoModal";
import ClientsCreateInfoModalMEELZ from "../clientsSectionModal/ClientsCreateInfoModal/ClientsCreateInfoModalMEELZ";
import { getConfig } from "../../../config";

const ClientsComponent = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenClientsImport, setIsOpenClientsImport] = useState(false);
  const [isOpenClientsInfoModal, setIsOpenClientsInfoModal] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const dispatch = useDispatch();
  const clientDefaults = useSelector((s) => s.appSettings.clientDefaults);

  // Clear search when component mounts
  useEffect(() => {
    dispatch(clientsActions.clearSearch());
  }, [dispatch]);

  return (
    <section className={css.wrap}>

      <section className={css.menuBlock}>
        <TitleMenuClientsComponent
          setIsOpen={setIsOpen}
          setIsOpenClientsImport={setIsOpenClientsImport}
        />
      </section>

      <section className={css.listBlock}>
        <ClientsListComponent />
      </section>

      {isOpenClientsInfoModal && (
        getConfig().projectCode === "MEELZ" ? (
          <ClientsCreateInfoModalMEELZ
            setIsOpenClientsInfoModal={setIsOpenClientsInfoModal}
            phoneNumber={phoneNumber}
            clientDefaults={clientDefaults}
          />
        ) : (
          <ClientsCreateInfoModal
            setIsOpenClientsInfoModal={setIsOpenClientsInfoModal}
            phoneNumber={phoneNumber}
            clientDefaults={clientDefaults}
          />
        )
      )}

      {isOpen && (
        <ClientsCreatePhoneClientModal
          setIsOpen={setIsOpen}
          setIsOpenClientsInfoModal={setIsOpenClientsInfoModal}
          setPhoneNumber={setPhoneNumber}
          clientDefaults={clientDefaults}
        />
      )}

      {isOpenClientsImport && (
        <ModalForImportXLS
          onClose={() => setIsOpenClientsImport(false)}
          titleName={"Import Clients"}
        />
      )}
    </section>
  );
};

export default React.memo(ClientsComponent);
